import React from 'react'
import Name from '@/components/Name'

const ReportSubmissionTitle = ({ reportSubmission }) => {
  if (reportSubmission) {
    const data = {
      name: reportSubmission.reportSubmissionGroupName,
      latinName: reportSubmission.reportSubmissionGroupLatinName
    }
    return (
      <span>(<Name data={data} />)</span>
    )
  }
  return null
}

export {
  ReportSubmissionTitle
}



// WEBPACK FOOTER //
// ./src/components/reporting/submissions/reportSubmissionTitle.js